import react, { useState } from 'react';
import styled from 'styled-components';
import "../landing.css"
import { GoComment } from "react-icons/go";
import { PiHandsPraying } from "react-icons/pi";
import { useSelector, useDispatch } from 'react-redux'; 
import { setLikePost } from '../../../features/landingPageSlice';
import SpinnerSmall from 'components/SpinnerSmall';
import SpinnerIntermintentSmall from 'loaders/SpinnerIntermintentSmall';


export default function Posts() {

    const dispatch = useDispatch();
    const { posts, likePostLoading } = useSelector((state) => state.landingPage);

    return ( 
        <ItemsWrapper2>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginTop: "20px",
                padding: "10px",
            }}>
                {
                    posts.map(post => (
                        <div class="post-card" key={post.id}>
                            <div class="post-header">
                                <div class="user-info">
                                    <div class="avatar" style={{backgroundColor: post.avatarBg}}>{post.initials}</div>
                                    <span class="user-name">{post.name}</span>
                                </div>
                                <span class="menu-dots">•••</span>
                            </div>
                            <div class="post-content"> {post.content} </div>
                            <div class="post-footer">
                                <div>  <GoComment /> Comment  </div>
                                <div 
                                    onClick={() => dispatch(setLikePost(post.id))}
                                    style={{backgroundColor: post.praying && "#00B4CC", color: post.praying && "white"}}
                                > 
                                    {
                                        likePostLoading === post.id ? ( 
                                            <SpinnerIntermintentSmall color={post.praying ? "white" : "#00B4CC"} size={"24px"} border={"3px"} />
                                        ) 
                                        : 
                                        (
                                            <>
                                                <span> <PiHandsPraying color={post.praying && "white" } /> </span> 
                                                {
                                                    post.praying ? ("You are praying") : ("Pray")
                                                }
                                            </>
                                        )
                                    }  
                                </div> 
                            </div>
                        </div>
                    ))
                }  
            </div>
        </ItemsWrapper2>
    )
}

const ItemsWrapper2 = styled.div`
    height: 100%;
    width: 100%; 
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    overflow-y: scroll;
    
`